import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirInvitationThemeSettings() {
  return {
    loading: true,
    saving: false,
    settings: { creator_share_percent: 70, platform_share_percent: 30 },
    engine: {
      section_count: 0,
      variant_count: 0,
      review_auto_approve: true,
      default_lock_version: true,
    },

    async init() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/invitation-marketplace/settings');
        this.settings = data.data || this.settings;
        this.engine = {
          section_count: 19,
          variant_count: 19,
          review_auto_approve: true,
          default_lock_version: true,
        };
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat pengaturan.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async save() {
      this.saving = true;
      try {
        const { data } = await axios.put('/api/v1/kasir/engagement/invitation-marketplace/settings', this.settings);
        this.settings = data.data || this.settings;
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },
  };
}

Alpine.data('kasirInvitationThemeSettings', createKasirInvitationThemeSettings);

export { createKasirInvitationThemeSettings };
